import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';

import { cn } from 'utils/cn';

interface AiDisclaimerProps {
  className?: string;
  variant?: 'inline' | 'block';
}

export function AiDisclaimer({
  className,
  variant = 'inline',
}: AiDisclaimerProps) {
  const { t } = useTranslation('common');

  return (
    <div
      className={cn(
        'flex items-center gap-1.5 text-xs text-gray-500',
        variant === 'block' && 'mt-2 pt-2 border-t border-gray-200',
        className
      )}
      data-cy="ai-disclaimer"
    >
      <Icon icon="mdi:information-outline" className="size-3.5 flex-shrink-0" />
      <span>{t('aiDisclaimer')}</span>
    </div>
  );
}
